exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown .dropdown-menu[data-v-3880f9de]{width:350px}.dropdown .dropdown-menu .note[data-v-3880f9de]{overflow-y:auto;max-height:200px}", ""]);

// exports
